module.exports = __webpack_public_path__ + "static/img/ic_secret@2x.d0dceee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_secret@2x.png
// module id = DwhB
// module chunks = 1